export const setStorageVariable = (
  key: string,
  value: string | number | boolean
) => {
  const stringValue = value.toString()
  localStorage.setItem(key, stringValue)
}

export const getStorageVariable = (key: string) => {
  const value = localStorage.getItem(key)?.toString()
  return value ? value : ""
}

export const deleteStorageVariable = (key: string) => {
  localStorage.removeItem(key)
}
